"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./ListAnswer.css");
var _react = require("react");
var _material = require("@mui/material");
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@mui/icons-material/CheckBoxOutlineBlank"));
var _TextAnswer = _interopRequireDefault(require("../TextAnswer/TextAnswer"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ListAnswer = function ListAnswer(props) {
  var _useState = (0, _react.useState)(props.existingAnswerValue ? props.existingAnswerValue : props.data.defaultOption ? props.data.defaultOption : null),
    _useState2 = _slicedToArray(_useState, 2),
    answerValue = _useState2[0],
    setAnswerValue = _useState2[1];
  var _useState3 = (0, _react.useState)(props.existingAnswerValue),
    _useState4 = _slicedToArray(_useState3, 2),
    existingAnswerValue = _useState4[0],
    setExistingAnswerValue = _useState4[1];
  var _useState5 = (0, _react.useState)(props.didSubmitAnswer),
    _useState6 = _slicedToArray(_useState5, 2),
    didSubmitAnswer = _useState6[0],
    setDidSubmitAnswer = _useState6[1];
  var flashAnimationDurationInMs = 800;
  (0, _react.useEffect)(function () {
    if (existingAnswerValue !== props.existingAnswerValue) {
      setExistingAnswerValue(props.existingAnswerValue);
    }
    if (didSubmitAnswer !== props.didSubmitAnswer) {
      setDidSubmitAnswer(props.didSubmitAnswer);
    }
  }, [props.existingAnswerValue, props.didSubmitAnswer]);
  (0, _react.useEffect)(function () {
    props.setAnswer(props.data.id, answerValue, didSubmitAnswer);
  }, [answerValue, didSubmitAnswer]);
  function selectAnswer(event, index) {
    if (answerValue === event.target.name) {
      setAnswerValue(null);
      return;
    }
    if (props.data.optionForAdditionalDetails && event.target.name == props.data.optionForAdditionalDetails) {
      setAnswerValue("Enter details"); // Wait for them to type details into the textbox
      return;
    }
    setAnswerValue(event.target.name);
    setTimeout(function () {
      return setDidSubmitAnswer(true);
    }, flashAnimationDurationInMs);
  }
  function isOtherOptionChecked() {
    if (!props.data.optionForAdditionalDetails || !answerValue) {
      return false;
    }
    var _iterator = _createForOfIteratorHelper(props.data.acceptableValues),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var option = _step.value;
        if (answerValue == option && option !== props.data.optionForAdditionalDetails) {
          return false;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return true;
  }
  function getIsChecked(value) {
    if (props.data.optionForAdditionalDetails && answerValue) {
      if (value !== props.data.optionForAdditionalDetails) {
        return value === answerValue;
      }

      // See if any of the other values are set
      var isAnotherValueSelected = false;
      var _iterator2 = _createForOfIteratorHelper(props.data.acceptableValues),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var option = _step2.value;
          if (answerValue == option && option !== props.data.optionForAdditionalDetails) {
            isAnotherValueSelected = true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return !isAnotherValueSelected;
    }
    return value === answerValue;
  }
  function setAnswerFromOtherDetails(id, answer, didSubmitAnswer) {
    setAnswerValue(answer);
    setDidSubmitAnswer(didSubmitAnswer);
  }
  if (!props.data.acceptableValues || props.data.acceptableValues.length == 0) {
    return;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "list-answer",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormGroup, {
      children: props.data.acceptableValues.map(function (option, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormControlLabel, {
          className: "list-choice ".concat(option === answerValue ? "option-selected flash" : ""),
          control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Checkbox, {
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {}),
            checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Check.default, {
              style: {
                fill: "#FFF",
                color: "#FFF"
              }
            }),
            checked: getIsChecked(option),
            onChange: function onChange(event) {
              return selectAnswer(event, index);
            },
            name: option,
            size: "medium"
          }),
          label: option
        }, option);
      })
    }), props.data.optionForAdditionalDetails && isOtherOptionChecked() ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "enter-other-details",
      children: [" ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextAnswer.default, _objectSpread(_objectSpread({}, props), {}, {
        setAnswer: setAnswerFromOtherDetails,
        placeholder: "Enter details",
        width: "300px",
        variant: "outlined"
      }))]
    }) : null]
  });
};
var _default = ListAnswer;
exports.default = _default;